import React from "react";
import Component from "./LinksList";
import IconButtonsList from "./IconsList";
import IconButton from "./IconButton";
import { createModalHelpers } from "@stores/unified-modal.store";
import WalletAddress from "@pages/Profile/components/WalletAddress";
import { useWallet } from "@stores/wallet.store";

interface CardHeaderProps {
    handleSettingsModal: () => void;
    handleReload: () => void;
    isLoading?: boolean;
}

const CardHeader: React.FC<CardHeaderProps> = ({ handleSettingsModal, handleReload, isLoading }) => {
    const modalHelpers = createModalHelpers();
    const { openModal } = modalHelpers;
    const isConnected = useWallet((state) => state.isConnected);
    return (
        // Removed 'relative' class
        <div className={"flex justify-between items-center relative"}>
            <div className="flex items-center gap-2">
                <Component />
                {isConnected ? <WalletAddress showSelectModal={() => openModal("select")} small /> : ""}
            </div>
            <IconButtonsList>
                <IconButton type="Reload" onClick={handleReload} />
                <IconButton type="Settings" onClick={handleSettingsModal} />
            </IconButtonsList>
        </div>
    );
};

export default CardHeader;
